import { WINDOW_HEIGHT, ADMIN_HEADER_HEIGHT } from '@/constants.js';

/**
 * 后台管理admin全局mixin
 */
const AdminGlobalMixin = {
    data() {
        return {
            adminContentMinHeight: 'auto' //后台管理admin-content部分渲染时的最小高度
        };
    },
    created() {
        let navHeaderHeight = ADMIN_HEADER_HEIGHT;
        let breadcrumbHeight = 50; //see css class(.admin-content-header) in index/admin.scss
        let adminContentBodyPadding = 15 * 2; //see css class(.admin-content-body) in index/admin.scss
        this.adminContentMinHeight = WINDOW_HEIGHT - navHeaderHeight - breadcrumbHeight - adminContentBodyPadding;
    }
};

export {
    AdminGlobalMixin
};